import React from "react";
import _ from "lodash";
import moment from "moment";
import Header from "../../components/Header";
import Firebase from "../../firebasehelper";
import "./index.css";
import SurveyMakerForm from "./SurveyMakerForm";
import EditSurveyModal from "./EditSurveyModal";

const Journeys = [
  {
    img: require("../../assets/media/chatbotmakers/ux.png"),
    title: "Proactively engage",
    text: "visitors 24/7 to shorten the time it takes to convert them.",
  },
  {
    img: require("../../assets/media/chatbotmakers/impact.png"),
    title: "Bespoke your bot",
    text: "UX, statements, personalisation, questions and answers.",
  },
  {
    img: require("../../assets/media/chatbotmakers/data-sharing.png"),
    title: "Collect and verify",
    text: "age, mobile, KYC, addresses and any binary information you wish.",
  },
  {
    img: require("../../assets/media/chatbotmakers/graph.png"),
    title: "Grow artificially ",
    text: "without any human interaction, as you propel referrals and deep insight.",
  },
  {
    img: require("../../assets/media/chatbotmakers/ecology-and-environment.png"),
    title: "Publish smoothly",
    text: "bot statements questions and answers to build smooth chats.",
  },
  {
    img: require("../../assets/media/chatbotmakers/analysis.png"),
    title: "Analyse results",
    text: "of your new auto service routings, editing your bots to reflect insights.",
  },
];
class SurveyMaker extends React.PureComponent {
  surveyForm = null;

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      brand: null,
      brandData: {},
      viewMode: 0,
      selectedSurveyId: null,
      publishBtnDisable: true,
      survey: null,
    };
  }

  async componentDidMount() {
    if (!this.props.location.state) {
      this.props.history.push("/");
    } else {
      const { brand, role, username } = this.props.location.state;
      this.setState({ brand, username, role, loading: true });

      Firebase.getBrandDataByID(brand, (brandData) => {
        this.setState({ brandData, loading: false });
      });
    }
  }

  handleInputChange = (event) => {
    const { survey } = this.state;
    const { name, value } = event.target;

    const newSurvey = _.cloneDeep(survey);
    newSurvey[name] = value;
    this.setState({ survey: newSurvey });
  };

  handleLayerChange = (index, key, value) => {
    const { survey } = this.state;
    const newSurvey = _.cloneDeep(survey);
    newSurvey["communicationLayers"][index][key] = value;
    this.setState({ survey: newSurvey });
  };

  addNewCommunicationLayer = () => {
    const { survey } = this.state;
    const newSurvey = _.cloneDeep(survey);
    newSurvey["communicationLayers"].push({ type: "", statement: "" });
    this.setState({ survey: newSurvey });
  };

  publishSurvey = (survey) => {
    const { brand } = this.state;
    Firebase.addBrandSurvey(brand, {
      ...survey,
      created_at: new Date(),
      users: 0,
    });
  };

  updateSurvey = (survey) => {
    const { brand } = this.state;
    Firebase.updateSurveyById(brand, this.state.selectedSurveyId, {
      ...survey,
      updated_at: new Date(),
    });
  };

  deleteSurvey = (_survey) => {
    const { brand } = this.state;
    Firebase.deleteSurveyById(brand, this.state.selectedSurveyId);
  };

  copyUrl = (survey_name) => {
    const { brandData } = this.state;
    let value = `https://ecosystem.club/${brandData.name.replace(
      /\s/g,
      ""
    )}?survey=${survey_name}`;
    navigator.clipboard.writeText(value);
  };
  renderNewSurvey = () => {
    const { survey, brandData } = this.state;
    return (
      <React.Fragment>
        <SurveyMakerForm
          ref={(ref) => (this.surveyForm = ref)}
          publishSurvey={this.publishSurvey}
          onUpdateStatus={(survey) => {
            this.setState({
              survey,
              publishBtnDisable: !survey.name || !survey.welcomeText,
            });
          }}
          uploadFolder={`surveys/${brandData.name}`}
          brandName={brandData.name}
        />

        <div className="survey-add-new-layer-options mt-3">
          {survey && survey.name && survey.welcomeText && (
            <button
              className="btn btn-brand-hex btn-white"
              style={{
                "--hover-text-color": brandData.white ? "white" : "black",
                "--hover-color": brandData.hex,
                backgroundColor: "white",
                color: "black",
              }}
              type="button"
              onClick={() =>
                this.surveyForm
                  ? this.surveyForm.addNewCommunicationLayer()
                  : null
              }
            >
              Add new communication layer
            </button>
          )}
        </div>
        <div className="survey-publish-options mt-3">
          {!this.state.publishBtnDisable && (
            <button
              className={`btn warning-button action-button`}
              type="button"
              onClick={() =>
                this.surveyForm ? this.surveyForm.handlePublishSurvey() : null
              }
              style={{ marginLeft: 20 }}
            >
              Publish the survey
            </button>
          )}
        </div>
      </React.Fragment>
    );
  };

  renderSurveys = () => {
    const { brandData } = this.state;
    const surveyIds = Object.keys(brandData.surveys || {});

    return (
      <React.Fragment>
        {surveyIds.map((id) => {
          const survey = brandData.surveys[id];
          return (
            <div className="survey-item" key={survey.name}>
              <div className="survey-item-icon">
                <img
                  width={60}
                  height={60}
                  src={brandData.icon}
                  alt="icon"
                ></img>
              </div>
              <div style={{ flex: 1 }}>
                <h4>Survey Name - {survey.name}</h4>
                <p>
                  Created - {moment(survey.created_at).format("DD.MM.YYYY")}
                </p>
                <p>Number of users - {survey.users}</p>
              </div>
              <div className="btn-container">
                <button
                  className="btn btn-primary action-button"
                  onClick={() => this.copyUrl(survey.name)}
                >
                  Copy to clipboard
                </button>
                <button
                  className="btn btn-brand-hex btn-white"
                  style={{
                    "--hover-text-color": brandData.white ? "white" : "black",
                    "--hover-color": brandData.hex,
                    backgroundColor: "white",
                    color: "black",
                  }}
                  data-toggle="modal"
                  data-target="#edit_survey_form_modal"
                  onClick={() => this.setState({ selectedSurveyId: id })}
                >
                  Edit
                </button>
              </div>
            </div>
          );
        })}
      </React.Fragment>
    );
  };

  render() {
    const { brand, loading, brandData, viewMode, selectedSurveyId } =
      this.state;

    let username = this.props.location.state.username;
    let role = this.props.location.state.role;

    return (
      <div id="page-container">
        <Header
          username={username}
          role={role}
          logo={brandData.logo}
          brand={brand}
          brandName={brandData.name}
          is_property_brand={brandData.is_property_brand}
        />
        <main id="main-container">
          <div className="home-content">
            {loading && (
              <div className="loading">
                <i className="fa fa-4x fa-sync fa-spin text-muted" />
              </div>
            )}
            {!loading && (
              <React.Fragment>
                <div className="survey-maker-content pb-5">
                  <div className="survey-maker-options">
                    <button
                      className={`btn`}
                      style={{
                        color:
                          viewMode === 0
                            ? brandData.white
                              ? "white"
                              : "black"
                            : "black",
                        backgroundColor:
                          viewMode === 0 ? brandData.hex : "white",
                      }}
                      type="button"
                      onClick={() => this.setState({ viewMode: 0 })}
                    >
                      New Survey
                    </button>
                    <button
                      className={`btn`}
                      style={{
                        color:
                          viewMode === 1
                            ? brandData.white
                              ? "white"
                              : "black"
                            : "black",
                        backgroundColor:
                          viewMode === 1 ? brandData.hex : "white",
                      }}
                      type="button"
                      onClick={() => this.setState({ viewMode: 1 })}
                    >
                      Survey archive
                    </button>
                  </div>
                  {viewMode === 0
                    ? this.renderNewSurvey()
                    : this.renderSurveys()}
                </div>
                <div className="journey-container">
                  {Journeys.map((obj, i) => (
                    <div className="journey-item" key={i}>
                      <div className="journey-item-avatar">
                        <img src={obj.img} alt="img" />
                      </div>
                      <b>{obj.title}</b>
                      <p>{obj.text}</p>
                    </div>
                  ))}
                </div>
              </React.Fragment>
            )}
          </div>
        </main>
        <EditSurveyModal
          survey={
            selectedSurveyId
              ? (brandData.surveys || {})[selectedSurveyId]
              : null
          }
          updateSurvey={this.updateSurvey}
          deleteSurvey={this.deleteSurvey}
          hex={brandData.hex}
          white={brandData.white}
          brandName={brandData.name}
        />
      </div>
    );
  }
}
export default SurveyMaker;



// WEBPACK FOOTER //
// ./src/screens/SurveyMaker/index.js